<template>
    <flex-element :element-type="elementType" tag="ul">
        <drawer
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :index="index"
            v-bind="element"
            :pointer="index + 1"
            :icon-collapsed="iconCollapsed"
            :icon-expanded="iconExpanded"
            :expanded-drawer-index="expandedDrawerIndex"
            :close-other-drawers="closeOtherDrawers"
            @expanded="onExpand"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [baseOrganism],

    data() {
        return {
            expandedDrawerIndex: -1,
            height: 0,
            isDrawerBodyVisible: false,

            iconImgCollapsed: '',
            iconImgExpanded: '',
        };
    },

    computed: {
        iconExpanded() {
            return this.hasElementData('drawer-icon-expanded') ? this.getElementData('drawer-icon-expanded') : 'chevron-up';
        },

        iconCollapsed() {
            return this.hasElementData('drawer-icon-collapsed') ? this.getElementData('drawer-icon-collapsed') : 'chevron-down';
        },

        closeOtherDrawers() {
            return this.getElementData('drawer-expand') === 'close-other-drawers';
        },
    },

    methods: {
        onExpand(drawerIndex) {
            this.expandedDrawerIndex = drawerIndex;
        },
    },
};
</script>
